import { Box, Typography } from "@mui/material";
import { Avatar } from "../../../../../components/fieldsViews/fields/Avatar";
import { useSessionStatusColor } from "../useSessionStatus";
import { TechPoolChipProps } from "../types.nfbAssign";

export const TechPoolChip = ({ therapist, ringStatus, subLabel, onClick }: TechPoolChipProps) => {
    const ringColor = useSessionStatusColor(ringStatus);
    const firstName = therapist.firstName?.trim().split(" ")[0] || "Sem nome";
    const lastNameInitial = therapist.lastName?.trim().charAt(0);
    const displayName = lastNameInitial ? `${firstName} ${lastNameInitial}.` : firstName;

    return (
        <Box
            onClick={onClick}
            sx={{
                display: "flex",
                flexDirection: "column",
                // near-avatar width so name/sub center on the image while it stays flush left
                alignItems: "center",
                gap: 0.4,
                minWidth: 38,
                cursor: onClick ? "pointer" : "default",
            }}
        >
            <Box sx={{ position: "relative" }}>
                <Box
                    sx={{
                        width: 34,
                        height: 34,
                        borderRadius: "50%",
                        boxShadow: `0 0 0 2.5px ${ringColor}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        backgroundColor: "white",
                    }}
                >
                    <Avatar value={therapist.avatar} styles={{ width: 34, height: 34 }} />
                </Box>
            </Box>
            <Typography
                sx={{
                    fontSize: 10,
                    fontWeight: 600,
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    // 48px cap + 16px column gap: adjacent names can never overlap (7px spill per side)
                    maxWidth: 48,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {displayName}
            </Typography>
            {subLabel ? (
                <Typography
                    sx={{
                        fontSize: 8.5,
                        fontWeight: 700,
                        color: ringColor,
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        fontVariantNumeric: "tabular-nums",
                        lineHeight: 1,
                    }}
                >
                    {subLabel}
                </Typography>
            ) : null}
        </Box>
    );
};
